import { useState, useRef } from 'react';
import axios, { AxiosResponse } from 'axios';

export interface IResponse {
    data: any[],
    status: string | number;
    message: string;
}
export const useHttpRequest = (baseHttpUrl?: string) => {

    const [error, setError] = useState<any>();
    const [loading, setLoading] = useState(false);
    const [progress, setProgress] = useState(0);
    const controller = useRef<AbortController>(
        new AbortController()
    );

    const sendRequest = async ({ url, method, body = null, params = null, headers = null, baseUrl = '' }
        : {
            url: string, method: 'post' | 'get' | 'put' | 'del' | 'delete',
            params?: any, body?: any, headers?: any, baseUrl?: string
        }) => {
        setLoading(true);
        setProgress(0);
        controller.current = new AbortController();
        let response: AxiosResponse<any, any> | null = null;
        try {
            const Authorization = axios.defaults.headers.common.Authorization;
            response = await axios.request({
                baseURL: baseHttpUrl ?? baseUrl,
                url: url,
                timeout: 0,
                headers: {
                    ...headers, Authorization
                },
                method: method,
                params: params,
                data: body,
                signal: controller.current.signal,
                onUploadProgress: (event) => {
                    setProgress((event.loaded) / event.total);
                },
            });
        } catch (err: any) {
            setError(err);
        } finally {
            setLoading(false);
        }
        return response?.data as IResponse;
    };

    const download = async ({ url, baseUrl = '' }
        : {
            url: string, baseUrl?: string
        }) => {
        setLoading(true);
        setProgress(0);
        controller.current = new AbortController();
        let response: AxiosResponse<any, any> | null = null;
        const Authorization = axios.defaults.headers.common.Authorization;
        try {
            response = await axios.request({
                baseURL: baseHttpUrl ?? baseUrl,
                url: url,
                timeout: 0,
                method: 'get',
                headers: {
                    Authorization,
                },
                responseType: 'blob',
                signal: controller.current.signal,
                onDownloadProgress: (event) => {
                    setProgress((event.loaded) / event.total);
                },
            });
        } catch (err: any) {
            setError(err);
        } finally {
            setLoading(false);
        }

        return response?.data as Blob;
    };
    const downloadPost = async ({ url, baseUrl = '', body }
        : {
            url: string, baseUrl?: string
            , body: any
        }) => {
        setLoading(true);
        setProgress(0);
        controller.current = new AbortController();
        let response: AxiosResponse<any, any> | null = null;
        const Authorization = axios.defaults.headers.common.Authorization;
        try {
            response = await axios.request({
                baseURL: baseHttpUrl ?? baseUrl,
                url: url,
                timeout: 0,
                method: 'post',
                data: body,
                headers: {
                    Authorization,
                    // 'Cache-Control': 'no-cache',
                    // 'Pragma': 'no-cache',
                    // 'Expires': '0'
                },
                responseType: 'blob',
                signal: controller.current.signal,
                onDownloadProgress: (event) => {
                    setProgress((event.loaded) / event.total);
                },
            });
        } catch (err: any) {
            setError(err);
        } finally {
            setLoading(false);
        }

        return response?.data as Blob;
    };
    const upload = async ({ url, baseUrl = '', body = null }
        : {
            url: string, baseUrl?: string, body?: any
        }) => {
        setLoading(true);
        setProgress(0);
        controller.current = new AbortController();
        let response: AxiosResponse<any, any> | null = null;
        const Authorization = axios.defaults.headers.common.Authorization;
        try {
            response = await axios.request({
                baseURL: baseHttpUrl ?? baseUrl,
                url: url,
                timeout: 0,
                method: 'post',
                headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization
                },
                data: body,
                signal: controller.current.signal,
                onUploadProgress: (event) => {
                    setProgress((event.loaded) / event.total);
                },
            });
        } catch (err: any) {
            setError(err);
        } finally {
            setTimeout(() => {
                setLoading(false);
            }, 500)
        }

        return response?.data as Blob;
    };


    const abort = () => {
        controller.current.abort();
    }
    return { sendRequest, error, loading, setloading : setLoading, abort, progress, setProgress, download, upload, downloadPost };
};

